<template>
  <div class="content lg flex-box vertical">
    <div class="content-title">
      <div class="content-title-text">图标管理</div>
      <div class="content-title-btn">
        <a-button type="primary" @click="showModal()">
          <a-icon type="plus-circle" /> 新增图标
        </a-button>
      </div>
    </div>
    <div class="gap"></div>
    <div class="icon-area flex-grow scroll-area">
      <ul class="icon-list" v-if="iconList && iconList.length > 0">
        <li class="icon-item" v-for="item in iconList" :key="item.id">
          <div class="img-box">
            <img :src="item.url" />
            <div class="icon-btn">
              <a-icon type="form" @click="showModal(item)" />
              <a-icon type="delete" @click="delIcon(item)" />
            </div>
          </div>
          <div class="img-title ellipsis">{{ item.name }}</div>
        </li>
      </ul>
    </div>
    <a-modal
      :maskClosable="false"
      v-model="visible"
      :title="title"
      ok-text="确认"
      cancel-text="取消"
      @ok="confirm"
    >
      <a-form-model
        class="icon-form"
        ref="iconForm"
        labelAlign="left"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
        :model="iconForm"
        :rules="rules"
      >
        <a-form-model-item label="图标" prop="url">
          <form-upload v-model="iconForm.url" :limit="1" />
        </a-form-model-item>
        <a-form-model-item label="图标名称" prop="name">
          <a-input
            v-model="iconForm.name"
            placeholder="请输入图标名称"
            :maxLength="10"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import formUpload from "../components/form/form-upload.vue";
export default {
  components: {
    formUpload,
  },
  name: "Icon",
  data() {
    return {
      iconList: [],

      iconForm: {
        url: "",
        name: "",
      },
      rules: {
        url: [
          {
            required: true,
            message: "请选择图标",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入图标名称",
            trigger: "blur",
          },
        ],
      },
      visible: false,
      title: "标题",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios({
        url: "/activity/activity-icon",
        method: "GET",
        params: {
          page: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        this.iconList = res?.data || [];
      });
    },
    showModal(item) {
      this.resetForm();
      if (item) {
        this.iconForm.id = item.id;
        this.iconForm.name = item.name;
        this.iconForm.url = item.url;
        this.title = "编辑图标";
      } else {
        this.title = "添加图标";
      }
      this.visible = true;
    },
    confirm() {
      this.$refs.iconForm.validate((valid) => {
        let form = this.iconForm;
        let id = form.id;
        if (valid) {
          let method = "POST";
          let url = "/activity/activity-icon";
          if (id) {
            url += `/${id}`;
            method = "PATCH";
          }
          this.$axios({
            url,
            method,
            data: {
              ...form,
            },
          }).then(() => {
            this.$message.success(id ? "更新成功" : "添加成功");
            this.getList();
            this.visible = false;
            this.resetForm();
          });
        }
      });
    },
    delIcon(item) {
      this.$confirm({
        title: "提示",
        content: "删除之后不可恢复，确认删除此图标吗？",
        onOk: () => {
          this.$axios({
            url: `/activity/activity-icon/${item.id}`,
            method: "DELETE",
          }).then(() => {
            this.$message.success("删除成功");
            this.getList();
          });
        },
      });
    },
    resetForm() {
      this.iconForm.id && delete this.iconForm.id;
      this.iconForm.name = "";
      this.iconForm.url = "";
    },
  },
};
</script>

<style lang="less" scoped>
.icon-item {
  display: inline-block;
  position: relative;
  margin: 0 10px 10px 10px;
  width: 48px;
  // height: 48px;
  text-align: center;
}
.img-box {
  position: relative;
  padding: 5px;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  line-height: 30px;
  width: 48px;
  box-sizing: border-box;
  border: var(--border);
  cursor: pointer;
  &:hover {
    border-color: var(--main-color);
    box-shadow: 0 0 6px #aed1f3;
    .icon-btn {
      display: flex;
    }
  }
}
.img-box img {
  width: 32px;
  height: 32px;
  vertical-align: middle;
}
.img-title {
  // margin-top: 5px;
}
.icon-btn {
  display: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 24px;
  color: #ffffff;
}
</style>
